import React, { useState } from "react";
import { X, DollarSign } from "lucide-react";
import { setItemCosts } from "../../services/catalogService";

const ItemCostsEditor = ({ selectedIds, costDefinitions, onClose, onDone }) => {
    const [costDefinitionId, setCostDefinitionId] = useState(costDefinitions[0]?.id || "");
    const [value, setValue] = useState("");
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const handleSave = async () => {
        if (!costDefinitionId || value === "") return;
        setSaving(true);
        setError("");
        try {
            await setItemCosts(selectedIds, costDefinitionId, parseFloat(value));
            onDone();
        } catch (e) {
            setError(e.message || "Failed to save costs");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
                <div className="bg-gradient-to-r from-teal-500 to-blue-600 px-6 py-4 flex items-center justify-between">
                    <h2 className="text-white font-bold text-lg flex items-center gap-2"><DollarSign size={18} /> Set Cost</h2>
                    <button onClick={onClose} className="text-white/70 hover:text-white"><X size={20} /></button>
                </div>
                <div className="p-6">
                    <p className="text-xs text-gray-400 mb-4">
                        Applying to <strong>{selectedIds.length}</strong> selected product{selectedIds.length !== 1 && "s"}.
                    </p>

                    <label className="text-xs font-semibold text-gray-600 mb-1 block">Cost Type</label>
                    <select value={costDefinitionId} onChange={(e) => setCostDefinitionId(e.target.value)}
                        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:border-teal-500">
                        {costDefinitions.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>

                    <label className="text-xs font-semibold text-gray-600 mb-1 block">Amount ($)</label>
                    <input type="number" step="0.01" value={value} onChange={(e) => setValue(e.target.value)}
                        placeholder="0.00" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:border-teal-500" />

                    {error && <p className="text-red-500 text-xs mb-3">{error}</p>}

                    <button onClick={handleSave} disabled={saving || !costDefinitionId || value === ""}
                        className="w-full py-3 bg-gradient-to-r from-teal-500 to-blue-600 text-white rounded-xl font-bold hover:opacity-90 transition disabled:opacity-50">
                        {saving ? "Saving..." : `Apply to ${selectedIds.length} item(s)`}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ItemCostsEditor;